import gql from 'graphql-tag';

const getContentList = gql`
  query listContentVersions(
    $entityUuid: String!
    $salesChannelUuid: String!
    $locale: String!
    $entityType: EntityPrimaryType!
  ) {
    listContentVersions(
      versionRequest: {
        entityUuid: $entityUuid
        entityType: $entityType
        salesChannelUuid: $salesChannelUuid
        locale: $locale
      }
    ) {
      id
      i18nUuid
      type
      timestamp
      version
      userUuid
      userName
    }
  }
`;

const switchRecordedContent = gql`
  mutation rollbackContent(
    $entityUuid: String!
    $i18nUuid: String!
    $id: Int!
    $entityType: EntityPrimaryType!
  ) {
    rollbackContent(
      rollbackRequest: {
        id: $id
        entityUuid: $entityUuid
        entityType: $entityType
        i18nUuid: $i18nUuid
      }
    )
  }
`;

export { getContentList, switchRecordedContent };
